<ng-container
    #user="user"
    lsAddClassEventTheme
    lsCashierHandler
    lsInitTagManager
    lsLoadUser
    lsMissionComplete
    lsOtpLinkVerify
    lsPromoCode
    lsUser
    lsVerifyEmail
    [code]="verifyCode"
    [lsPing]="60"
    [verifyEmailParam]="projectParams.EMAIL_VERIFY"
    (lsOnMissionComplete)="handleMissionComplete($event)"
    (lsOnSuccess)="promoCodeActivated($event)"
    (lsOnVerifyFailed)="emailVerifyFailed($event)"
    (lsOnVerifySuccess)="emailVerifySuccess()"
    (lsUserLoaded)="userLoaded()"
    (lsUserStatusChange)="userStatusChange($event)"
>
    @if (!hideHeader) {
        <ls-header
            [balance]="user.userBalanceInfo$ | async"
            [hideHeaderPromo]="hideHeaderPromo"
            [isProfilePage]="isProfilePage"
            [user]="user.userInfo$ | async"
            (lsToggleMenu)="toggleMenu()"
        />
    }

    <div class="content">
        <main
            class="main"
            [class._fotter-hide]="hideFooter"
            [class._header-hide]="hideHeader"
        >
            <router-outlet (activate)="activate()" />
        </main>

        @if (!hideFooter) {
            <ls-footer/>
        }
    </div>

    @if (!hideMenu) {
        <ls-menu/>
    }

    @if (!hideArguments) {
        <ls-cookies/>
    }

    @if (!hideBottomMenu) {
        <ls-bottom-menu
            class="app__bottom-menu"
            [isProfilePage$]="isProfilePage"
        />
    }

    @if (!hideBottomBanner) {
        <ls-bottom-banner/>
    }
</ng-container>

@if (notificationObservable$ | async; as items) {
    <ls-ui-notification-box
        [items]="items"
        [notificationIcons]="notificationIcons"
        (handleItemClose)="handleClose($event)"
    />
}

<ng-container
    lsOnlineStatus
    (lsOnlineStatusChange)="handleStatusChange($event)"
/>
